module.exports = __webpack_public_path__ + "img/title.1af97eb9.png";